/* eslint-disable max-len */
import { RouteRecordRaw } from "vue-router";

import { metaRequireGuest } from "@/router/meta-constants";
import LoginPage from "@/views/login/index.vue";

const authenticateRoutes: Array<RouteRecordRaw> = [
    {
        path: "/login",
        name: "Login",
        meta: {
            ...metaRequireGuest,
            isHidenNatigation: true,
        },
        component: LoginPage,
    },
];

export default authenticateRoutes;
